var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_vm._v(" ProfilePage "), _c('div', [_vm._v(_vm._s(_vm.user))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }